//Popup d'alerte
$(function() {
	(function($, window, undefined) {
		window.App.Component.Alert = (function() {
			
			//Ids des popups déjà existante
			var alertElemId =  {
				alert: '#dialog-alert',
				error: '#dialog-alert',
				success: '#dialog-success',
				warning: '#dialog-warning'
			};
			
			var buttonsTemplateId = '.dialog-buttons-template';
						
			//Paramètres par défauts
			var defaultParams = {
				classes : false,
				buttons: { active: false }
			};
			
			var defaultButtons = {
				validateLabel: __('alert.validate'),
				cancelLabel: __('alert.cancel')
			};
			
			//Efface les classes et les messages
			function clean() {
				for(var alert in alertElemId) {
					var classes = $(alertElemId[alert]).find('[data-classes]');
					classes.removeClass();
					var errorsList = $(alertElemId[alert]).find('.dialog-error-list');
					errorsList.empty();
				}
			}
			
			/**
			 * @param {string|jQuery} content Contenu du message
			 * @param {string} type Type d'alerte
			 * @param {type} title Titre de la popup
			 * @param {type} params Paramètres additionnels
			 * @returns {Boolean}
			 */
			function showPopup(content, type, title, params) {
				if(typeof type == 'undefined') {
					type = 'alert';
				}
				var $alertElem = $(alertElemId[type]);
				if (!$alertElem.length) {
					console.warn('Alert Reveal doesnt exist');
					return false;
				}
				
				clean();
				if(typeof title != 'undefined') {
					$alertElem.find('.title').html(title);
				}
				
				var usedParams = $.extend({}, defaultParams, params, true);
				//Ajout des classes
				if (typeof usedParams['classes'] === 'string' && usedParams['classes']) {
					var classes = $alertElem.find('[data-classes]');
					classes.addClass(usedParams.classes);
				}
				
				$alertElem.find('.content').html(content);
				
				//Ajouts de boutons de validation
				if (typeof usedParams['buttons'] === 'object' && !$.isEmptyObject(usedParams['buttons'])) {
					if (usedParams['buttons']['active']) {
						var $buttonsTemplate = $(buttonsTemplateId);
						if ($buttonsTemplate.length) {
							var buttons = $buttonsTemplate.first().html();
							//On ajoute les boutons en remplaçant par les libellés mis en paramètre
							$alertElem.find('.content').append(templateRender(buttons, {
								validate_label: typeof usedParams.buttons.validateLabel === 'undefined' ? 
								defaultButtons.validateLabel : usedParams.buttons.validateLabel,
								cancel_label:  typeof usedParams.buttons.cancelLabel === 'undefined' ? 
								defaultButtons.cancelLabel : usedParams.buttons.cancelLabel
							}));
						} else {
							console.warn('Dialog Buttons template doesnt exist');
						}
					}
				}
				
				$alertElem.foundation('open');
			}
			
			function close() {
				var $alertElem = $(alertElemId);
				if (!$alertElem.length) {
					console.warn('Alert Reveal doesnt exist');
					return false;
				}
				$alertElem.foundation('close');
			}
						
			return {
				//showContent: showContent,
				showPopup: showPopup,
				close: close
			};
		})();
	})(jQuery, window, undefined);
});